import { render, staticRenderFns } from "./CSidecoverTopics.vue?vue&type=template&id=635699ee&"
import script from "./CSidecoverTopics.vue?vue&type=script&lang=ts&"
export * from "./CSidecoverTopics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports